import React from 'react';
import { Typography, styled, Box } from '@material-ui/core';

const WhatsNextBox = styled(Box)(({ theme }) => ({
  borderRadius: 8,
  maxWidth: 541,
  margin: 'auto',
  padding: 16,
  paddingBottom: 'none',
  marginBottom: 40,
  backgroundColor: theme.palette.info.main,
}));

const ItemContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  marginBottom: 16,
});

interface ListBoxWithIconsProps {
  title: string;
  listItems: {
      icon: string;
      listText: string;
  }[];
}

export const ListBoxWithIcons: React.FC<ListBoxWithIconsProps> = ({
  title,
  listItems,
}) => (
  <WhatsNextBox>
    <Typography variant="body2" style={{ alignSelf: 'center', marginBottom: 16 }}>{title}</Typography>
    {listItems.map((listItem) => (
      <ItemContainer key={listItem.listText}>
        <img width="48px" src={listItem.icon} alt={listItem.listText} />
        <Typography>
          {listItem.listText}
        </Typography>
      </ItemContainer>
    ))}
  </WhatsNextBox>
);
